export const requestDefaults = {
	cacheTime: 300000, // 5 min
};
